export function isStaging() {
    const host = window.location.hostname;
    return host.includes("staging") || host === "cashmate-staging.web.app" || host.includes("localhost");
  }